import type { Editor } from "@tiptap/react";

import { useCallback } from "react";

interface UseQuickPromptOptions {
  editor: Editor | null;
  onSelectUploadImage: () => void;
  onSelectProduct: () => void;
}

/**
 * NOTE (Kevin, 2025-08-18): Custom hook for handling quick prompt actions in chat interfaces.
 * Supports setting editor content and triggering upload/product actions.
 */
export const useQuickPrompt = ({
  editor,
  onSelectUploadImage,
  onSelectProduct,
}: UseQuickPromptOptions) => {
  const handleQuickPrompt = useCallback(
    (prompt: string, action?: string) => {
      if (!editor) {
        return;
      }

      // Use insertContent instead of setContent to preserve trailing whitespace
      editor.commands.setContent("", false);
      editor.commands.insertContent(prompt);

      if (action === "upload") {
        onSelectUploadImage();
      }

      if (action === "product") {
        onSelectProduct();
      }
    },
    [editor, onSelectUploadImage, onSelectProduct],
  );

  return handleQuickPrompt;
};
